"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPaymentUI = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var legacy_queries_1 = require("../../../../../shared/api/legacy-queries");
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var utils_1 = require("../../../utils");
var StyledCardPayment_styled_1 = require("./StyledCardPayment.styled");
var components_2 = require("./components");
var CardPaymentUI = function (_a) {
    var _b;
    var balance = _a.balance, accountId = _a.accountId, lastBillAmount = _a.lastBillAmount, predictedFinalBalance = _a.predictedFinalBalance, calculationEndDate = _a.calculationEndDate, lastBillableDate = _a.lastBillableDate, isDebtRisk = _a.isDebtRisk;
    var search = window.location.search;
    var amountFromParams = (0, core_1.getValueFromQueryParams)('amount', search);
    var _c = __read((0, react_1.useState)((0, utils_1.getDefaultAmount)(amountFromParams)), 2), amount = _c[0], setAmount = _c[1];
    var _d = __read((0, react_1.useState)([]), 2), errors = _d[0], setErrors = _d[1];
    var cardPaymentStatus = (0, core_1.useLinks)().cardPaymentStatus;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var payments = (0, core_1.useLinks)().payments;
    var colors = (0, styled_components_1.useTheme)().colors;
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _e.copy, Copy = _e.Copy;
    var _f = (0, core_1.useComponents)(), CurrencyField = _f.CurrencyField, Card = _f.Card, Heading1 = _f.Heading1, Stack = _f.Stack, ErrorSummaryNotification = _f.ErrorSummaryNotification, PrimaryCTAButton = _f.PrimaryCTAButton, Icon = _f.Icon, ErrorSection = _f.ErrorSection, Callout = _f.Callout;
    var retailer = core_1.configService.getConfig().retailer;
    var currencyCode = (0, utils_1.getCurrency)(retailer.currencyCode).code;
    var cardPaymentMutation = (0, legacy_queries_1.useCardPaymentLegacyMutation)(accountId, function (response) {
        window.location.href = (0, utils_1.createCardPaymentUrl)(amount, response, cardPaymentStatus());
    });
    var handleValueChange = function (_a) {
        var value = _a.currentTarget.value;
        setAmount(value);
    };
    var setAmountFromChip = function (chipId, setAmount) {
        switch (chipId) {
            case 'lastBill':
                if (lastBillAmount && Number(lastBillAmount.grossCharge.pounds) > 0) {
                    setAmount((0, utils_1.formatSmart2DPNoCurrency)(Number(lastBillAmount.grossCharge.pounds)));
                }
                else {
                    setAmount('');
                }
                break;
            case 'predictedDebt':
                if (predictedFinalBalance && Number(predictedFinalBalance) < 0) {
                    setAmount((0, utils_1.formatSmart2DPNoCurrency)(Math.abs(Number(predictedFinalBalance))));
                }
                else {
                    setAmount('');
                }
                break;
            case 'fullBalance':
                if (balance !== undefined) {
                    setAmount((0, utils_1.formatSmart2DPNoCurrency)(Math.abs(Number(balance))));
                }
                else {
                    setAmount('');
                }
                break;
            case 'fixed50':
                setAmount('50');
                break;
            case 'fixed100':
                setAmount('100');
                break;
            default:
                setAmount('');
        }
    };
    var newBalanceAmount = balance
        ? parseFloat(balance) + parseFloat(amount)
        : null;
    // we want this to display if newBalanceAmount is 0
    // newBalance is NaN on first load
    var newBalance = newBalanceAmount !== null && !isNaN(newBalanceAmount)
        ? (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(newBalanceAmount))
        : null;
    var newBalanceFull = newBalanceAmount === 0 || newBalanceAmount === null
        ? newBalance
        : newBalanceAmount >= 0
            ? "".concat(newBalance, " in credit")
            : "".concat(newBalance, " in debit");
    var handleSubmit = function (event) {
        event.preventDefault();
        setErrors([]);
        var numericAmount = Number(amount);
        if (cardPaymentMutation.status === 'in-progress') {
            return;
        }
        if (!/^\d+(\.\d\d?)?$/.test(amount)) {
            setErrors([
                {
                    id: 'amount',
                    message: copy('cardPaymentErrorInvalidAmount'),
                },
            ]);
        }
        else if (numericAmount < 0.01 || numericAmount > 5000) {
            setErrors([
                {
                    id: 'amount',
                    message: copy('cardPaymentErrorAmountRange'),
                },
            ]);
        }
        else {
            cardPaymentMutation.mutate({ amount: (0, utils_1.formatAsPence)(amount) });
            dispatch({
                name: analytics_subjects_1.CARD_PAYMENT_SUBMITTED,
                type: 'click',
                properties: {
                    paymentAmount: amount,
                    lastBillAmount: (lastBillAmount === null || lastBillAmount === void 0 ? void 0 : lastBillAmount.grossCharge.pounds) || null,
                    currentBalanceAmount: balance,
                },
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        cardPaymentMutation.status === 'error' ? (react_1.default.createElement(ErrorSection, { id: "api-error" })) : null,
        react_1.default.createElement(ErrorSummaryNotification, { id: "error-summary", errors: errors }),
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CARD_PAYMENT_BACK_BREADCRUMB, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                    react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: payments() }, react_1.default.createElement(Copy, { copyKey: "backtoPaymentsBreadcrumb" }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Heading1, null,
                        react_1.default.createElement(Copy, { copyKey: "cardPaymentHeading" })),
                    balance && (react_1.default.createElement(Callout, { "data-testid": "callout" },
                        react_1.default.createElement(Copy, { copyKey: "currentBalanceCallout", props: { currentBalance: balance } })))),
                react_1.default.createElement("form", { onSubmit: handleSubmit, method: "POST", noValidate: true },
                    react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                        react_1.default.createElement(core_1.Feature, { feature: "suggestedPayments", shouldLogEvent: true }, function (isEnabled) {
                            return isEnabled ? (react_1.default.createElement(components_2.SuggestedAmounts, { currentBalance: balance, lastBillAmount: lastBillAmount, predictedFinalBalance: predictedFinalBalance, calculationEndDate: calculationEndDate, lastBillableDate: lastBillableDate, isDebtRisk: isDebtRisk, onClick: function (id) { return setAmountFromChip(id, setAmount); } })) : null;
                        }),
                        react_1.default.createElement(CurrencyField, { "data-testid": "card-payment-amount", id: "amount", label: copy('cardPaymentAmountLabel'), value: amount, onChange: handleValueChange, disabled: cardPaymentMutation.status === 'in-progress', min: 0.01, max: 5000, error: (0, nebula_1.getErrorMessage)('amount', errors), characters: 8, currency: currencyCode })),
                    newBalance && (react_1.default.createElement(Copy, { copyKey: "cardPaymentNewBalance", values: { newBalance: newBalanceFull } })),
                    react_1.default.createElement(StyledCardPayment_styled_1.StyledSecureWrapper, null,
                        react_1.default.createElement(StyledCardPayment_styled_1.StyledIconWrapper, null,
                            react_1.default.createElement(Icon, { name: "secure", size: 20, color: colors.primary })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Copy, { copyKey: "cardPaymentWorldPay" }))),
                    react_1.default.createElement(PrimaryCTAButton, { id: "checkout-button", "data-testid": "make-card-payment-button", type: "submit", icon: true, disabled: cardPaymentMutation.status === 'in-progress' },
                        react_1.default.createElement(Copy, { copyKey: "cardPaymentSubmit" })))))));
};
exports.CardPaymentUI = CardPaymentUI;
